import { render } from "./product-card.vue?vue&type=template&id=2900b15e"
import script from "./product-card.vue?vue&type=script&lang=js"
export * from "./product-card.vue?vue&type=script&lang=js"

import "./product-card.vue?vue&type=style&index=0&id=2900b15e&lang=css"
script.render = render

export default script